import React from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';


const MobileSessionListItem = ({ 
  expanded,
  caseId,
  sessionId,
  startTime,
  endTime,
  isComplete,
  lastScreenSaved,
  handleExpandChange, 
  recallSession,
  languageName,
  languageCode,
  t
}) => (
  <ExpansionPanel 
    expanded={expanded}
    onChange={handleExpandChange(caseId)}>
    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
      <Typography>{caseId}</Typography>
    </ExpansionPanelSummary>
    <ExpansionPanelDetails>
      <Typography>
        <strong>{t('Start')}</strong> {startTime} <br />
        <strong>{t('End')}</strong> {endTime || '---'} <br />
        <strong>{t('Complete')}</strong> {isComplete} <br />
        <strong>{t('Last Page')}</strong> {lastScreenSaved.length > 0 ? t(lastScreenSaved) : '---'}<br />
        {languageCode.toLowerCase()!== 'en' && (
          <a 
            href="#/"
            onClick={() => recallSession(sessionId, '/session/translation')}
          >{`${t('Translate from')} ${languageName}`}</a>
        )}
      </Typography>
    </ExpansionPanelDetails>
    <Divider />
    <ExpansionPanelActions>
      <Button
        size="small"
        color="primary"
        onClick={() => recallSession(sessionId)}
      >{isComplete.toLowerCase() === 'yes' ? t('Results') : t('Last Page')}</Button>
    </ExpansionPanelActions>          
  </ExpansionPanel>  
)

MobileSessionListItem.propTypes = {
  expanded: PropTypes.bool,
  caseId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  sessionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  isComplete: PropTypes.string,
  lastScreenSaved: PropTypes.string,
  handleExpandChange: PropTypes.func,
  recallSession: PropTypes.func
}

export default translate()(MobileSessionListItem)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Mobile/SessionListItem.js